var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileDrawerRoundtrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.773,
    height: 21.906,
    viewBox: "0 0 15.773 21.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939",
    transform: "translate(-31.959 -558.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1122",
    "data-name": "Path 1122",
    transform: "translate(38.795 570.227)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.189485549926758 8.993049621582031 C 2.335104703903198 7.630127906799316 0.5000045299530029 4.400981426239014 0.5000045299530029 3.205928087234497 C 0.5000045299530029 1.71387791633606 1.713874459266663 0.4999979734420776 3.205924510955811 0.4999979734420776 C 4.697974681854248 0.4999979734420776 5.911844730377197 1.71387791633606 5.911844730377197 3.205928087234497 C 5.911844730377197 4.239748477935791 4.519750118255615 6.844191551208496 3.189485549926758 8.993049621582031 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.205924510955811 0.9999980926513672 C 1.989574432373047 0.9999980926513672 1.000004291534424 1.989577770233154 1.000004291534424 3.205927848815918 C 1.000004291534424 3.342447757720947 1.064694404602051 4.144087791442871 2.341784477233887 6.52581787109375 C 2.635771989822388 7.074099540710449 2.932703256607056 7.591983795166016 3.192004680633545 8.027950286865234 C 4.531584739685059 5.785377025604248 5.411844253540039 3.893834114074707 5.411844253540039 3.205927848815918 C 5.411844253540039 1.989577770233154 4.422274589538574 0.9999980926513672 3.205924510955811 0.9999980926513672 M 3.205924510955811 -1.9073486328125e-06 C 4.976504325866699 -1.9073486328125e-06 6.411844730377197 1.435338020324707 6.411844730377197 3.205927848815918 C 6.411844730377197 4.976508140563965 3.237094402313232 9.851818084716797 3.205924510955811 9.905808448791504 C 3.205757141113281 9.906098365783691 3.205496788024902 9.906243324279785 3.205148935317993 9.906243324279785 C 3.140740156173706 9.906243324279785 4.291534423828125e-06 4.966998100280762 4.291534423828125e-06 3.205927848815918 C 4.291534423828125e-06 1.435338020324707 1.435344696044922 -1.9073486328125e-06 3.205924510955811 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#e13505"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1123",
    "data-name": "Path 1123",
    transform: "translate(33.795 558.227)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.189485549926758 8.993049621582031 C 2.335104703903198 7.630127906799316 0.5000045299530029 4.400981426239014 0.5000045299530029 3.205928087234497 C 0.5000045299530029 1.71387791633606 1.713874459266663 0.4999979734420776 3.205924510955811 0.4999979734420776 C 4.697974681854248 0.4999979734420776 5.911844730377197 1.71387791633606 5.911844730377197 3.205928087234497 C 5.911844730377197 4.239748477935791 4.519750118255615 6.844191551208496 3.189485549926758 8.993049621582031 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.205924510955811 0.9999980926513672 C 1.989574432373047 0.9999980926513672 1.000004291534424 1.989577770233154 1.000004291534424 3.205927848815918 C 1.000004291534424 3.342447757720947 1.064694404602051 4.144087791442871 2.341784477233887 6.52581787109375 C 2.635771989822388 7.074099540710449 2.932703256607056 7.591983795166016 3.192004680633545 8.027950286865234 C 4.531584739685059 5.785377025604248 5.411844253540039 3.893834114074707 5.411844253540039 3.205927848815918 C 5.411844253540039 1.989577770233154 4.422274589538574 0.9999980926513672 3.205924510955811 0.9999980926513672 M 3.205924510955811 -1.9073486328125e-06 C 4.976504325866699 -1.9073486328125e-06 6.411844730377197 1.435338020324707 6.411844730377197 3.205927848815918 C 6.411844730377197 4.976508140563965 3.237094402313232 9.851818084716797 3.205924510955811 9.905808448791504 C 3.205757141113281 9.906098365783691 3.205496788024902 9.906243324279785 3.205148935317993 9.906243324279785 C 3.140740156173706 9.906243324279785 4.291534423828125e-06 4.966998100280762 4.291534423828125e-06 3.205927848815918 C 4.291534423828125e-06 1.435338020324707 1.435344696044922 -1.9073486328125e-06 3.205924510955811 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#e13505"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M16989.762-18676l2.063,2.064-2.062,2.064",
    transform: "translate(18708.313 17560.734) rotate(-90)",
    fill: "none",
    stroke: "#e13505",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M16989.762-18676l2.063,2.064-2.062,2.064",
    transform: "translate(-18628.621 -16422.004) rotate(90)",
    fill: "none",
    stroke: "#e13505",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M16916.314-18727.359v-6.73h-3",
    transform: "translate(16950.691 -18158.27) rotate(180)",
    fill: "none",
    stroke: "#e13505",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M16916.314-18727.359v-6.73h-3",
    transform: "translate(-16871 19297)",
    fill: "none",
    stroke: "#e13505",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_297",
    "data-name": "Ellipse 297",
    transform: "translate(41 572)",
    fill: "#fff",
    stroke: "#e13505",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_298",
    "data-name": "Ellipse 298",
    transform: "translate(36 560)",
    fill: "#fff",
    stroke: "#e13505",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDrawerRoundtrip);
export default __webpack_public_path__ + "static/media/mobile-drawer-roundtrip.100674017a95e4c6af1969e4bfde9419.svg";
export { ForwardRef as ReactComponent };